<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(title)"
        :before-close="elementDialogClose"
        :visible.sync="dialogVisible"
        width="690px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        append-to-body
    >
        <el-form :model="formGroupElementInfo" label-position="right" label-width="95px" ref="formGroupElementInfo" :rules="rules">
            <el-row :gutter="11">
                <el-col :span="11">
                    <el-form-item :label="$t('pgCommon.ELEMENT_TYPE')" prop="elementType">
                        <td-select v-model="formGroupElementInfo.elementType" :options="optionsElement" :disabled="elementDisabled" @change="elementChange"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('pgCommon.BELONG_TO_GROUP')" prop="sGroupId">
                        <td-select v-model="formGroupElementInfo.sGroupId" :disabled="true" :options="optionsGroup" keys="taskKey" text="taskName" :clearable="false" @change="groupChange"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="inputFlag">
                    <el-form-item :label="$t('pgCommon.INPUT_TYPE')" prop="sElementPropVal">
                        <td-select v-model="formGroupElementInfo.sElementPropVal" :options="sElementPropsJsons" :disabled="elementDisabled"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.SHOW_NAME')" prop="sViewName" v-if="!taskAuthFlag">
                        <td-select
                            v-model="formGroupElementInfo.sViewName"
                            :url="viewUrl"
                            :urlParam="viewUrlParam"
                            :isPage="true"
                            :pageSize="10"
                            requestType="POST"
                            keys="sElementFlg"
                            text="sName"
                            :sName="sName"
                        >
                        </td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.SHOW_ORDER')" prop="iOrder">
                        <td-input-number v-model="formGroupElementInfo.iOrder" :min="1" :max="500"> </td-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.SHOW_FORMAT')" prop="iColNum">
                        <td-select v-model="formGroupElementInfo.iColNum" :options="optionsFormat" :clearable="false"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.ELEMENT_HIDDEN')">
                        <td-radio v-model="formGroupElementInfo.iHidden" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('extendCommon.ELEMENT_NOT_NULL')">
                        <td-radio v-model="formGroupElementInfo.iNeeded" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item :label="$t('pgCommon.READ_ONLY')">
                        <td-radio v-model="formGroupElementInfo.readOnly" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="taskAuthFlag">
                    <el-form-item :label="$t('pgCommon.TASK_AUTH')" prop="nextAuth">
                        <td-select v-model="formGroupElementInfo.nextAuth" :options="optionsAuths"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="inputFlag">
                    <el-form-item :label="$t('pgCommon.PLACE_HOLDER')" prop="placeholder">
                        <td-input v-model="formGroupElementInfo.placeholder"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="inputFlag">
                    <el-form-item :label="$t('pgCommon.DEFAULT_VALUE')" prop="defaultValue">
                        <td-input v-model="formGroupElementInfo.defaultValue"> </td-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="selectFlag">
                    <el-form-item :label="$t('common.EXTENDDATA')"><td-radio v-model="formGroupElementInfo.selectRadio" :options="optionsRadio"></td-radio></el-form-item>
                    <el-form-item :label="$t('pgCommon.SELECT_OPTIONS')" prop="selectOptionsStr" v-if="!formGroupElementInfo.selectRadio">
                        <td-input v-model="formGroupElementInfo.selectOptionsStr" type="textarea" :placeholder="optionsDemo"> </td-input>
                    </el-form-item>
                    <el-form-item :label="$t('pgCommon.SELECT_OPTIONS')" prop="sTag" v-if="formGroupElementInfo.selectRadio">
                        <td-select v-model="formGroupElementInfo.sTag" :placeholder="$t('common.PLEASE_SELECT')" :options="this.dictDataList" keys="sTag" text="sTag" :clearable="true"> </td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="11" v-if="selectFlag">
                    <el-form-item :label="$t('pgCommon.ELEMENT_SELECTS')" prop="selects">
                        <td-radio v-model="formGroupElementInfo.selects" :options="requiredType"></td-radio>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formGroupElementInfo')" :loading="submitLoading">{{ $t('extendCommon.SAVE') }}</td-button>
            <td-button @click="elementDialogClose">{{ $t('extendCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
import vPinyin from './../assets/vue-py.js';
export default {
    props: ['title', 'dialogVisible', 'editItem', 'isAddData', 'maxExtendOrder', 'groupId', 'templateId', 'templateKey', 'taskKey', 'taskName'],
    created() {
        this.initGroupList();
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.elementDisabled = true;
            this.keyDisabled = true;
            this.initEditData();
        } else {
            // 默认新增排序字段为当前数据库中最大的排序字段值
            this.formGroupElementInfo.iOrder = this.maxExtendOrder;
            this.formGroupElementInfo.iColNum = this.optionsFormat[0].value;
            // this.formGroupElementInfo.sElementId = this.groupId + ':' + vPinyin.chineseToPinYin(this.formGroupElementInfo.sViewName);
        }
        Api.getDictTypeList('', response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message.error({ showClose: true, message: response.data.statusMessage });
                this.$log.error('dict/getDictTypeList', response.data.statusMessage);
                return;
            }
            this.dictDataList = response.data.content;
        });
    },
    // 定义变量
    data() {
        let validateElementKey = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formGroupElementInfo.sId;
            }
            let param = {
                sId: sId,
                sGroupId: this.groupId,
                sElementKey: this.formGroupElementInfo.sViewName
            };
            Api.checkElementKey(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/checkElementKey', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('extendError.ERROR_ELEMENT_KEY_EXIST'));
                } else {
                    callback();
                }
            });
        };
        return {
            viewUrl: '/extendManage/listProcessElementInfo',
            viewUrlParam: {
                sId: this.templateKey + ':'
            },
            dictDataList: [],
            optionsDemo: '选项之间以"、"号分割，如选项一、选项二、选项三、选项四、......',
            elementDisabled: false, //扩展元素下拉框可用性
            keyDisabled: false, //元素关键字可用性
            inputFlag: false,
            selectFlag: false,
            taskAuthFlag: false,
            optionsRadio: [{ value: false, label: this.$t('extendCommon.MANUAL_INPUT') }, { value: true, label: this.$t('extendCommon.DICT') }],
            optionsAuths: [
                {
                    value: 'upLeavel',
                    label: '默认上级'
                },
                {
                    value: 'downLeavel',
                    label: '默认下级'
                },
                {
                    value: 'handle',
                    label: '用户手动'
                }
            ],
            // 扩展元素数组
            optionsElement: [
                {
                    value: 'TdInput',
                    label: this.$t('pgCommon.TD_INPUT')
                },
                {
                    value: 'TdSelect',
                    label: this.$t('pgCommon.TD_SELECT')
                },
                {
                    value: 'TdDateTime',
                    label: this.$t('pgCommon.TD_TIME')
                },
                {
                    value: 'TdInputNumber',
                    label: this.$t('pgCommon.TD_NUMBER')
                },
                {
                    value: 'nextUsers',
                    label: this.$t('pgCommon.NEXT_USERS')
                },
                {
                    value: 'nextGroups',
                    label: this.$t('pgCommon.NEXT_GROUPS')
                }
            ],
            sElementPropsJsons: [],
            // 扩展元素属性数组
            optionsElementProps: [],
            // 扩展元素属性数组
            optionsElementEvents: [],
            //所属扩展组
            optionsGroup: [],
            // 表单信息
            formGroupElementInfo: {
                sTag: '',
                selectRadio: false,
                sId: '',
                sGroupId: '',
                sElementId: '',
                elementType: '',
                sViewName: '',
                iOrder: 1,
                iColNum: '',
                iHidden: 1,
                iNeeded: 1,
                iShowLabel: 0,
                sOptionName: 'options',
                sElementProp: '',
                sElementVal: '',
                sElementKey: '',
                sElementEvent: '',
                sElementPropVal: '',
                sElementEventVal: '',
                sElementPropsJson: {},
                sElementEventsJson: '',
                placeholder: '',
                defaultValue: '',
                selectOptionsStr: '',
                selectOptions: [],
                readOnly: 1,
                selects: 1,
                sRegex: '',
                sRegexInfo: '',
                nextAuth: ''
            },
            submitLoading: false, // 保存按钮是否为加载状态
            optionsFormat: [
                {
                    value: 24,
                    label: this.$t('pgCommon.A_ROW')
                },
                {
                    value: 12,
                    label: this.$t('pgCommon.B_ROW')
                }
            ],
            requiredType: [
                //请求类型
                {
                    value: 0,
                    label: this.$t('extendCommon.IS_TRUE')
                },
                {
                    value: 1,
                    label: this.$t('extendCommon.DENY')
                }
            ],
            // 对表单进行数据验证
            rules: {
                elementType: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_SELECT_ELEMENT'), trigger: 'change' }],
                sElementPropVal: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_SELECT_ELEMENT'), trigger: 'change' }],
                sElementKey: [
                    { required: true, message: this.$t('extendError.ERROR_PLEASE_INPUT_ELEMENT_KEY'), trigger: 'blur' },
                    { pattern: window.tdExtend.regex.ENGLISH_AND_NUM_UNDERLINE, message: this.$t('extendRegex.ONLY_ENGLISH_NUM_UNDERLINE'), trigger: 'blur' }
                ],
                sViewName: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_SHOW_NAME'), trigger: 'change' }, { validator: validateElementKey, trigger: 'blur' }],
                sGroupId: [{ required: true, message: this.$t('extendError.ERROR_PLEASE_SELECT_GROUP'), trigger: 'change' }],
                selectOptionsStr: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_INPUT_OPTIONS'), trigger: 'change' }],
                nextAuth: [{ required: true, message: this.$t('pgError.ERROR_PLEASE_SELECT_AUTH'), trigger: 'change' }]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 将元素属性转化为json串
        createPropsJson() {
            if (null != this.formGroupElementInfo.defaultValue && '' != this.formGroupElementInfo.defaultValue) {
                this.formGroupElementInfo.sElementPropsJson.value = this.formGroupElementInfo.defaultValue;
            }
            if (null != this.formGroupElementInfo.placeholder && '' != this.formGroupElementInfo.placeholder) {
                this.formGroupElementInfo.sElementPropsJson.placeholder = this.formGroupElementInfo.placeholder;
            }
            if (null != this.formGroupElementInfo.sElementPropVal && '' != this.formGroupElementInfo.sElementPropVal) {
                this.formGroupElementInfo.sElementPropsJson.type = this.formGroupElementInfo.sElementPropVal;
            }
            if (this.formGroupElementInfo.selects == 0) {
                this.formGroupElementInfo.sElementPropsJson.multiple = true;
            } else {
                this.formGroupElementInfo.sElementPropsJson.multiple = false;
            }
            if (this.formGroupElementInfo.elementType == 'nextUsers' && this.formGroupElementInfo.nextAuth == 'handle') {
                this.formGroupElementInfo.sElementPropsJson.multiple = true;
                this.formGroupElementInfo.sElementPropsJson.url = '/auth/user/getUserInfos';
                this.formGroupElementInfo.sElementPropsJson.urlParam = {
                    sSysFlg: this.$common.systemInfo.systemId
                };
                this.formGroupElementInfo.sElementPropsJson.isPage = true;
                this.formGroupElementInfo.sElementPropsJson.pageSize = 10;
                this.formGroupElementInfo.sElementPropsJson.requestType = 'POST';
                this.formGroupElementInfo.sElementPropsJson.keys = 'userId';
                this.formGroupElementInfo.sElementPropsJson.text = 'userName';
                this.formGroupElementInfo.sElementPropsJson.sName = 'userName';
            }
            if (this.formGroupElementInfo.elementType == 'nextGroups' && this.formGroupElementInfo.nextAuth == 'handle') {
                this.formGroupElementInfo.sElementPropsJson.multiple = true;
                this.formGroupElementInfo.sElementPropsJson.url = '/auth/role/getRoleAuthList';
                this.formGroupElementInfo.sElementPropsJson.urlParam = {
                    sysFlg: this.$common.systemInfo.systemId
                };
                this.formGroupElementInfo.sElementPropsJson.isPage = true;
                this.formGroupElementInfo.sElementPropsJson.pageSize = 10;
                this.formGroupElementInfo.sElementPropsJson.requestType = 'POST';
                this.formGroupElementInfo.sElementPropsJson.keys = 'roleId';
                this.formGroupElementInfo.sElementPropsJson.text = 'roleName';
                this.formGroupElementInfo.sElementPropsJson.sName = 'roleName';
            }
            if (this.formGroupElementInfo.selectRadio == true) {
                this.formGroupElementInfo.sElementPropsJson.url = '/setting/dictController/getDictValuesByType';
                this.formGroupElementInfo.sElementPropsJson.urlParam = {
                    sTag: this.formGroupElementInfo.sTag
                };
                this.formGroupElementInfo.sElementPropsJson.isPage = true;
                this.formGroupElementInfo.sElementPropsJson.pageSize = 10;
                this.formGroupElementInfo.sElementPropsJson.requestType = 'POST';
                this.formGroupElementInfo.sElementPropsJson.sName = 'label';
            }
        },
        initAllFlag() {
            this.inputFlag = false;
            this.selectFlag = false;
            this.taskAuthFlag = false;
        },
        // 初始化编辑数据
        initEditData() {
            console.log(this.editItem);
            this.formGroupElementInfo.sId = this.editItem.sId;
            this.formGroupElementInfo.sGroupId = this.editItem.sGroupId;
            this.formGroupElementInfo.sElementId = this.editItem.sElementId;
            // this.formGroupElementInfo.sViewName = this.editItem.sViewName;
            this.formGroupElementInfo.iOrder = this.editItem.iOrder;
            this.formGroupElementInfo.iColNum = this.editItem.iColNum;
            this.formGroupElementInfo.iHidden = this.editItem.iHidden;
            this.formGroupElementInfo.iNeeded = this.editItem.iNeeded;
            this.formGroupElementInfo.iShowLabel = this.editItem.iShowLabel;
            this.formGroupElementInfo.sOptionName = this.editItem.sOptionName;
            this.formGroupElementInfo.sElementKey = this.editItem.sElementKey;
            this.formGroupElementInfo.sElementPropsJson = this.editItem.sElementPropsJson;
            // this.groupChange(this.formGroupElementInfo.sGroupId);
            // this.formGroupElementInfo.sElementEventsJson = this.editItem.sElementEventsJson;
        },
        // 初始化所属扩展组下拉框数据
        initGroupList() {
            let param = {
                templateId: this.templateId,
                templateKey: this.templateKey
            };
            Api.getNodeInfo(param, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.$log.error('queryTemplate', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('queryTemplate', response.data.statusMessage);
                    return;
                }
                this.optionsGroup = response.data.content;
                this.formGroupElementInfo.sGroupId = this.taskKey;
            });
        },
        // 下拉选项字典改变
        dictTagChange(val) {
            if (null == val || '' == val) {
                return;
            }
            let param = {
                sTag: val
            };
            Api.getDictValuesByType(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message.error({ showClose: true, message: response.data.statusMessage });
                    this.$log.error('setting/getDictValuesByType', response.data.statusMessage);
                    return;
                }
                let res = response.data.content;
                let options = [];
                for (let index = 0; index < res.length; index++) {
                    const element = res[index];
                    options.push({ value: element.value, label: element.label });
                }
                this.formGroupElementInfo.selectOptions = options;
            });
        },
        // 元素类型改变
        elementChange(data) {
            this.initAllFlag();
            if (data == 'TdInput') {
                this.inputFlag = true;
                this.sElementPropsJsons = [
                    {
                        value: 'password',
                        label: this.$t('pgCommon.PASSWORD')
                    },
                    {
                        value: 'color',
                        label: this.$t('pgCommon.COLOR')
                    },
                    {
                        value: 'email',
                        label: this.$t('pgCommon.EMAIL')
                    },
                    {
                        value: 'text',
                        label: this.$t('pgCommon.TEXT')
                    },
                    {
                        value: 'textarea',
                        label: this.$t('pgCommon.TEXTAREA')
                    },
                    {
                        value: 'url',
                        label: this.$t('pgCommon.URL')
                    }
                ];
            } else if (data == 'TdSelect') {
                this.selectFlag = true;
            } else if (data == 'nextUsers') {
                this.taskAuthFlag = true;
                this.selectFlag = false;
            } else if (data == 'nextGroups') {
                this.taskAuthFlag = true;
                this.selectFlag = false;
                this.inputFlag = false;
            }
        },
        groupChange(data) {
            if (this.$util.isEmpty(data)) {
                this.formGroupElementInfo.sElementKey = '';
            }
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    // 下环节权限元素，设置特定元素id
                    if (this.formGroupElementInfo.elementType == 'nextUsers' || this.formGroupElementInfo.elementType == 'nextGroups') {
                        this.formGroupElementInfo.sElementId = this.templateKey + ':' + this.formGroupElementInfo.elementType + ':' + this.formGroupElementInfo.nextAuth;
                    } else {
                        // 普通元素，设置普通元素id
                        this.formGroupElementInfo.sElementId = this.templateKey + ':' + this.formGroupElementInfo.sViewName;
                    }
                    // 创建元素属性
                    this.createPropsJson();
                    this.submitLoading = true;
                    if (this.isAddData) {
                        let param = {
                            sGroupFlg: this.groupId
                        };
                        // 校验是否存在该表单
                        Api.checkGroupInfo(JSON.stringify(param), response => {
                            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('extendManage/checkGroupInfo', response.data.statusMessage);
                                return;
                            }
                            if (response.data.count == 0) {
                                // 不存在该表单，新建并保存该表单
                                var content = {
                                    sId: this.groupId,
                                    sName: this.taskName,
                                    sGroupFlg: this.groupId
                                };
                                Api.insertExtendGroup(JSON.stringify(content), response => {
                                    if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                        this.$log.error('extendManage/insertExtendGroup', response.data.statusMessage);
                                        this.submitLoading = false;
                                        return;
                                    }
                                    // 新增流程扩展表的关联关系
                                    let link = {
                                        sGroupId: this.groupId
                                    };
                                    Api.insertExtProLink(JSON.stringify(link), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('extendManage/insertExtProLink', response.data.statusMessage);
                                            this.submitLoading = false;
                                            return;
                                        }
                                    });
                                });
                            }
                        });
                        // 校验是否存在该元素
                        Api.checkElementSId(
                            JSON.stringify({
                                sId: this.formGroupElementInfo.sElementId
                            }),
                            response => {
                                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                    this.$log.error('extendManage/checkElementSId', response.data.statusMessage);
                                    return;
                                }
                                if (response.data.count == 0) {
                                    // 不存在该元素，新建并保存该元素
                                    let dataSource = 0;
                                    if (!this.formGroupElementInfo.selectRadio) {
                                        // 创建下拉选项数组
                                        if (this.formGroupElementInfo.selectOptionsStr != '' && this.formGroupElementInfo.selectOptionsStr != null) {
                                            let options = this.formGroupElementInfo.selectOptionsStr.split('、');
                                            options.forEach(item => {
                                                let obj = {
                                                    value: item,
                                                    label: item
                                                };
                                                this.formGroupElementInfo.selectOptions.push(obj);
                                            });
                                        }
                                    } else if (this.formGroupElementInfo.selectRadio) {
                                        dataSource = 1;
                                    }
                                    let elementParam = {
                                        sId: this.formGroupElementInfo.sElementId,
                                        sName: '',
                                        sViewName: 'Process',
                                        sElementType: this.formGroupElementInfo.elementType,
                                        sElementFlg: '',
                                        iDataSource: dataSource,
                                        sOptionData: JSON.stringify(this.formGroupElementInfo.selectOptions),
                                        sRegex: this.formGroupElementInfo.sRegex,
                                        sRegexInfo: this.formGroupElementInfo.sRegexInfo
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'handle') {
                                        elementParam.sElementType = 'TdSelect';
                                    } else if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        elementParam.sElementType = 'TdInput';
                                    }
                                    if (this.formGroupElementInfo.elementType == 'nextUsers') {
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType + ':' + this.formGroupElementInfo.nextAuth;
                                        elementParam.sName = this.$t('pgCommon.NEXT_USERS');
                                    } else if (this.formGroupElementInfo.elementType == 'nextGroups') {
                                        elementParam.sElementFlg = this.formGroupElementInfo.elementType + ':' + this.formGroupElementInfo.nextAuth;
                                        elementParam.sName = this.$t('pgCommon.NEXT_GROUPS');
                                    }
                                    Api.insertExtendElement(JSON.stringify(elementParam), response => {
                                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message.error({ showClose: true, message: response.data.statusMessage });
                                            this.$log.error('extendManage/insertExtendElement', response.data.statusMessage);
                                            return;
                                        }
                                    });
                                    // 保存表单和元素关联关系和元素属性
                                    let content = {
                                        sGroupId: this.groupId,
                                        sElementId: this.formGroupElementInfo.sElementId,
                                        sElementKey: elementParam.sElementFlg,
                                        sViewName: elementParam.sName,
                                        iOrder: this.formGroupElementInfo.iOrder,
                                        iColNum: this.formGroupElementInfo.iColNum,
                                        iHidden: this.formGroupElementInfo.iHidden,
                                        iNeeded: this.formGroupElementInfo.iNeeded,
                                        iShowLabel: this.formGroupElementInfo.iShowLabel,
                                        sOptionName: this.formGroupElementInfo.sOptionName,
                                        sElementPropsJson: JSON.stringify(this.formGroupElementInfo.sElementPropsJson),
                                        sElementEventsJson: this.formGroupElementInfo.sElementEventsJson
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        // 隐藏自动权限组件
                                        content.iHidden = 0;
                                    }
                                    Api.insertGroupElement(JSON.stringify(content), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('extendManage/insertGroupElement', response.data.statusMessage);
                                            this.submitLoading = false;
                                            return;
                                        }
                                        this.submitLoading = false;
                                        this.$message({ showClose: true, message: this.$t('extendCommon.ADD_SUCCESS'), type: 'success' });
                                        this.elementDialogClose();
                                        /* 编辑或添加完成需调用查询接口 */
                                        this.$emit('callbackQuery');
                                    });
                                } else {
                                    // 更新该元素
                                    let dataSource = 0;
                                    if (!this.formGroupElementInfo.selectRadio) {
                                        if (this.formGroupElementInfo.selectOptionsStr != '' && this.formGroupElementInfo.selectOptionsStr != null) {
                                            let options = this.formGroupElementInfo.selectOptionsStr.split('、');
                                            options.forEach(item => {
                                                let obj = {
                                                    value: item,
                                                    label: item
                                                };
                                                this.formGroupElementInfo.selectOptions.push(obj);
                                            });
                                        }
                                    } else if (this.formGroupElementInfo.selectRadio) {
                                        dataSource = 1;
                                    }
                                    let elementParam = {
                                        sId: response.data.content[0].sId,
                                        sName: response.data.content[0].sName,
                                        sViewName: 'Process',
                                        sElementType: this.formGroupElementInfo.elementType,
                                        sElementFlg: response.data.content[0].sElementFlg,
                                        iDataSource: dataSource,
                                        sOptionData: JSON.stringify(this.formGroupElementInfo.selectOptions),
                                        sRegex: this.formGroupElementInfo.sRegex,
                                        sRegexInfo: this.formGroupElementInfo.sRegexInfo
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'handle') {
                                        elementParam.sElementType = 'TdSelect';
                                    } else if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        elementParam.sElementType = 'TdInput';
                                    }
                                    Api.updateExtendElement(JSON.stringify(elementParam), response => {
                                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message.error({ showClose: true, message: response.data.statusMessage });
                                            this.$log.error('extendManage/updateExtendElement', response.data.statusMessage);
                                            return;
                                        }
                                    });
                                    // 保存表单和元素关联关系和元素属性
                                    let content = {
                                        sGroupId: this.groupId,
                                        sElementId: this.formGroupElementInfo.sElementId,
                                        sElementKey: response.data.content[0].sElementFlg,
                                        sViewName: elementParam.sName,
                                        iOrder: this.formGroupElementInfo.iOrder,
                                        iColNum: this.formGroupElementInfo.iColNum,
                                        iHidden: this.formGroupElementInfo.iHidden,
                                        iNeeded: this.formGroupElementInfo.iNeeded,
                                        iShowLabel: this.formGroupElementInfo.iShowLabel,
                                        sOptionName: this.formGroupElementInfo.sOptionName,
                                        sElementPropsJson: JSON.stringify(this.formGroupElementInfo.sElementPropsJson),
                                        sElementEventsJson: this.formGroupElementInfo.sElementEventsJson
                                    };
                                    if (this.formGroupElementInfo.nextAuth == 'upLeavel' || this.formGroupElementInfo.nextAuth == 'downLeavel') {
                                        content.iHidden = 0;
                                    }
                                    Api.insertGroupElement(JSON.stringify(content), response => {
                                        if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                            this.$log.error('extendManage/insertGroupElement', response.data.statusMessage);
                                            this.submitLoading = false;
                                            return;
                                        }
                                        this.submitLoading = false;
                                        this.$message({ showClose: true, message: this.$t('extendCommon.ADD_SUCCESS'), type: 'success' });
                                        this.elementDialogClose();
                                        /* 编辑或添加完成需调用查询接口 */
                                        this.$emit('callbackQuery');
                                    });
                                }
                            }
                        );
                    } else {
                        Api.updateGroupElement(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('extendManage/updateGroupElement', response.data.statusMessage);
                                this.submitLoading = false;
                                return;
                            }
                            this.submitLoading = false;
                            this.$message({ showClose: true, message: this.$t('extendCommon.MODIFY_SUCCESS'), type: 'success' });
                            this.elementDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('callbackQuery');
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        elementDialogClose() {
            this.dialogVisible = false;
            this.$emit('elementDialogClose');
        },
        createJson(prop, val, props) {
            // 如果 val 被忽略
            if (typeof val === 'undefined' || val === '') {
                // 删除属性
                delete props[prop];
            } else {
                // 添加 或 修改
                props[prop] = val;
            }
        },
        strMapToObj(strMap) {
            let obj = Object.create(null);
            for (let [k, v] of strMap) {
                obj[k] = v;
            }
            return obj;
        },
        elementPorpChange(option) {
            this.formGroupElementInfo.sElementPropVal = '';
            console.log(option);
        },
        elementEventsChange(option) {
            this.formGroupElementInfo.sElementEventVal = '';
            console.log(option);
        },
        // 获取UUID
        getUUID() {
            return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
                let r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    }
};
</script>
<style></style>
